export const translations = {
  en: {
    // Auth
    welcome_back: 'Welcome Back',
    create_account: 'Create Account',
    sign_in: 'Sign in to manage your jobs',
    sign_up: 'Sign up to get started',
    username: 'Username',
    password: 'Password',
    sign_in_button: 'Sign In',
    sign_up_button: 'Sign Up',
    dont_have_account: "Don't have an account? Sign up",
    already_have_account: 'Already have an account? Sign in',
    
    // Dashboard
    all_jobs: 'All Jobs',
    total_jobs: 'total jobs',
    create_new_job: 'Create New Job',
    no_jobs_yet: 'No jobs yet',
    create_first_job: 'Create your first job to get started',
    logout: 'Logout',
    settings: 'Settings',
    show_filters: 'Show Filters',
    hide_filters: 'Hide Filters',
    
    // Filters
    filter_jobs: 'Filter Jobs',
    client_name: 'Client Name',
    search_by_client: 'Search by client name',
    employee: 'Employee',
    all_employees: 'All employees',
    apply_filters: 'Apply Filters',
    clear: 'Clear',
    
    // Job Form
    create_job: 'Create New Job',
    edit_job: 'Edit Job',
    address: 'Address',
    enter_address: 'Enter job address',
    use_my_location: 'Use My Location',
    date: 'Date',
    main_technician: 'Main Technician',
    enter_technician: 'Enter technician name',
    description: 'Description',
    describe_work: 'Describe the work that was done',
    photos: 'Photos',
    maximum: 'Maximum',
    upload_from_device: 'Upload from device',
    select_multiple: 'Select multiple photos',
    take_photos: 'Take photos',
    use_camera: 'Use camera',
    photos_added: 'photos added',
    cancel: 'Cancel',
    save_changes: 'Save Changes',
    update_job: 'Update Job',
    mobile_tip: '📱 Mobile tip: Use "Upload from device" to select photos from your gallery for better reliability. Camera photos are compressed to 600x600px to prevent crashes.',
    price: 'Price',
    enter_price: 'Enter job price (optional)',
    status: 'Status',
    pending: 'Pending',
    completed: 'Completed',
    invoice_sent: 'Invoice Sent',
    mark_completed: 'Mark as Completed',
    mark_invoice_sent: 'Mark Invoice as Sent',
    mark_invoice_button: 'Mark Invoice as Sent',
    created_on: 'Created on',
    
    // Job Details
    job_details: 'Job Details',
    edit: 'Edit Job',
    delete: 'Delete',
    created_by: 'Created By',
    
    // Delete Dialog
    delete_job_title: 'Delete Job?',
    delete_confirmation: 'Are you sure you want to delete this job for',
    delete_warning: 'This action cannot be undone and will permanently remove all job details and photos.',
    delete_job_button: 'Delete Job',
    
    // Settings
    account_settings: 'Account Settings',
    update_credentials: 'Update your username and password',
    profile_info: 'Profile Information',
    current_username: 'Current username',
    owner: 'Owner',
    current_password: 'Current Password',
    enter_current_password: 'Enter your current password',
    required_for_changes: 'Required to make any changes',
    change_username: 'Change Username',
    new_username: 'New Username',
    enter_new_username: 'Enter new username (optional)',
    keep_current_username: 'Leave blank to keep current username',
    change_password: 'Change Password',
    new_password: 'New Password',
    enter_new_password: 'Enter new password (optional)',
    min_characters: 'Minimum 6 characters. Leave blank to keep current password',
    confirm_password: 'Confirm New Password',
    confirm_new_password: 'Confirm new password',
    
    // Messages
    login_successful: 'Login successful!',
    account_created: 'Account created successfully!',
    job_created: 'Job created successfully!',
    job_updated: 'Job updated successfully!',
    job_deleted: 'Job deleted successfully!',
    profile_updated: 'Profile updated successfully!',
    getting_location: 'Getting your location...',
    address_autofilled: 'Address auto-filled from your location!',
    photo_captured: 'Photo captured!',
    compressing_photos: 'Compressing photos...',
    photos_ready: 'photos ready!',
    auto_saved: 'Auto-saved',
  },
  es: {
    // Auth
    welcome_back: 'Bienvenido de Nuevo',
    create_account: 'Crear Cuenta',
    sign_in: 'Inicia sesión para gestionar tus trabajos',
    sign_up: 'Regístrate para comenzar',
    username: 'Usuario',
    password: 'Contraseña',
    sign_in_button: 'Iniciar Sesión',
    sign_up_button: 'Registrarse',
    dont_have_account: '¿No tienes cuenta? Regístrate',
    already_have_account: '¿Ya tienes cuenta? Inicia sesión',
    
    // Dashboard
    all_jobs: 'Todos los Trabajos',
    total_jobs: 'trabajos totales',
    create_new_job: 'Crear Nuevo Trabajo',
    no_jobs_yet: 'Aún no hay trabajos',
    create_first_job: 'Crea tu primer trabajo para comenzar',
    logout: 'Cerrar Sesión',
    settings: 'Configuración',
    show_filters: 'Mostrar Filtros',
    hide_filters: 'Ocultar Filtros',
    
    // Filters
    filter_jobs: 'Filtrar Trabajos',
    client_name: 'Nombre del Cliente',
    search_by_client: 'Buscar por nombre del cliente',
    employee: 'Empleado',
    all_employees: 'Todos los empleados',
    apply_filters: 'Aplicar Filtros',
    clear: 'Limpiar',
    
    // Job Form
    create_job: 'Crear Nuevo Trabajo',
    edit_job: 'Editar Trabajo',
    address: 'Dirección',
    enter_address: 'Ingresar dirección del trabajo',
    use_my_location: 'Usar Mi Ubicación',
    date: 'Fecha',
    main_technician: 'Técnico Principal',
    enter_technician: 'Ingresar nombre del técnico',
    description: 'Descripción',
    describe_work: 'Describe el trabajo que se realizó',
    photos: 'Fotos',
    maximum: 'Máximo',
    upload_from_device: 'Subir desde dispositivo',
    select_multiple: 'Seleccionar múltiples fotos',
    take_photos: 'Tomar fotos',
    use_camera: 'Usar cámara',
    photos_added: 'fotos agregadas',
    cancel: 'Cancelar',
    save_changes: 'Guardar Cambios',
    update_job: 'Actualizar Trabajo',
    mobile_tip: '📱 Consejo móvil: Usa "Subir desde dispositivo" para seleccionar fotos de tu galería para mayor confiabilidad. Las fotos de la cámara se comprimen a 600x600px para evitar fallas.',
    price: 'Precio',
    enter_price: 'Ingresa el precio del trabajo (opcional)',
    status: 'Estado',
    pending: 'Pendiente',
    completed: 'Completado',
    invoice_sent: 'Factura Enviada',
    mark_completed: 'Marcar como Completado',
    mark_invoice_sent: 'Marcar Factura como Enviada',
    mark_invoice_button: 'Marcar Factura como Enviada',
    created_on: 'Creado el',
    
    // Job Details
    job_details: 'Detalles del Trabajo',
    edit: 'Editar Trabajo',
    delete: 'Eliminar',
    created_by: 'Creado Por',
    
    // Delete Dialog
    delete_job_title: '¿Eliminar Trabajo?',
    delete_confirmation: '¿Estás seguro de que quieres eliminar este trabajo para',
    delete_warning: 'Esta acción no se puede deshacer y eliminará permanentemente todos los detalles y fotos del trabajo.',
    delete_job_button: 'Eliminar Trabajo',
    
    // Settings
    account_settings: 'Configuración de Cuenta',
    update_credentials: 'Actualiza tu usuario y contraseña',
    profile_info: 'Información del Perfil',
    current_username: 'Usuario actual',
    owner: 'Propietario',
    current_password: 'Contraseña Actual',
    enter_current_password: 'Ingresa tu contraseña actual',
    required_for_changes: 'Requerido para hacer cambios',
    change_username: 'Cambiar Usuario',
    new_username: 'Nuevo Usuario',
    enter_new_username: 'Ingresa nuevo usuario (opcional)',
    keep_current_username: 'Dejar en blanco para mantener el usuario actual',
    change_password: 'Cambiar Contraseña',
    new_password: 'Nueva Contraseña',
    enter_new_password: 'Ingresa nueva contraseña (opcional)',
    min_characters: 'Mínimo 6 caracteres. Dejar en blanco para mantener la contraseña actual',
    confirm_password: 'Confirmar Nueva Contraseña',
    confirm_new_password: 'Confirma nueva contraseña',
    
    // Messages
    login_successful: '¡Inicio de sesión exitoso!',
    account_created: '¡Cuenta creada exitosamente!',
    job_created: '¡Trabajo creado exitosamente!',
    job_updated: '¡Trabajo actualizado exitosamente!',
    job_deleted: '¡Trabajo eliminado exitosamente!',
    profile_updated: '¡Perfil actualizado exitosamente!',
    getting_location: 'Obteniendo tu ubicación...',
    address_autofilled: '¡Dirección completada desde tu ubicación!',
    photo_captured: '¡Foto capturada!',
    compressing_photos: 'Comprimiendo fotos...',
    photos_ready: 'fotos listas!',
    auto_saved: 'Guardado automático',
  }
};

export const getTranslation = (key, language = 'en') => {
  return translations[language]?.[key] || translations.en[key] || key;
};
